import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../features/statusModal/statusModal";
import AlertCircleIcon from "../icons/AlertCircleIcon";
import CheckCircleIcon from "../icons/CheckCircleIcon";
import CloseIcon from "../icons/CloseIcon";
import InfoCircleIcon from "../icons/InfoCircleIcon";
import styles from "./statusModal.module.css";

// How long a toast stays; hovering it pauses the countdown (CSS).
const DURATION_MS = 5000;
// Matches .leaving's animation, so it's gone the moment it has faded out.
const LEAVE_MS = 200;

const VARIANTS = {
  success: { Icon: CheckCircleIcon, title: "تمت العملية بنجاح" },
  error: { Icon: AlertCircleIcon, title: "تعذّر تنفيذ العملية" },
  event: { Icon: InfoCircleIcon, title: "تحديث جديد" },
};

const StatusModal = ({ status, message, id }) => {
  const dispatch = useDispatch();
  const [leaving, setLeaving] = useState(false);
  const variant = VARIANTS[status] ? status : "event";
  const { Icon, title } = VARIANTS[variant];

  const close = useCallback(() => setLeaving(true), []);

  useEffect(() => {
    if (!leaving) return undefined;
    const timer = setTimeout(() => dispatch(hideModal({ id })), LEAVE_MS);
    return () => clearTimeout(timer);
  }, [leaving, dispatch, id]);

  return (
    <div
      role={variant === "error" ? "alert" : "status"}
      dir="rtl"
      className={`${styles.toast} ${styles[variant]} ${leaving ? styles.leaving : ""}`}
    >
      <span className={styles.icon}>
        <Icon />
      </span>
      <div className={styles.body}>
        <p className={styles.title}>{title}</p>
        <p className={styles.message}>{message}</p>
      </div>
      <button
        type="button"
        className={styles.close}
        aria-label="إغلاق"
        onClick={close}
      >
        <CloseIcon />
      </button>
      {/* The countdown: when it has drained, the toast leaves. */}
      <span
        className={styles.progress}
        style={{ animationDuration: `${DURATION_MS}ms` }}
        onAnimationEnd={close}
      />
    </div>
  );
};

export default StatusModal;
